<div class="sw-cms-preview-block-moorl-grid-layout-seven">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
</div>